import {
  useOrientationContext,
  Orientation,
} from '../contexts/OrientationContext';
import { useMemo } from 'react';

interface OrientationHook {
  orientation: Orientation;
  isLandscape: boolean;
  isPortrait: boolean;
  isMobilePortrait: boolean;
  requiresLandscape: boolean;
}

/**
 * Custom hook for accessing device orientation status
 * @returns OrientationHook object with orientation details
 */
export const useOrientation = (): OrientationHook => {
  const context = useOrientationContext();

  if (!context) {
    throw new Error(
      'useOrientation must be used within an OrientationProvider'
    );
  }

  // Memoize the result to prevent unnecessary re-renders
  return useMemo(
    () => ({
      ...context,
      requiresLandscape: true, // This application always requires landscape mode
    }),
    [context]
  ); // Use context as dependency to ensure all properties are tracked
};

export default useOrientation;
